<template>
    <div>
        <main role="main" 
			style = "
				padding-top:0px;
				display: flex;
				flex-direction: column;
                justify-content: center;
                align-items: center;
				height: 50vh;
				text-align: center;
			" 
			class="right_wrapper"
		>
            <div style="text-align: center; vertical-align: middle; font-size: x-large;">
                Access Denied
            </div>
            <div style="text-align: center; vertical-align: middle;">
                You are not authorized to view this page. If you believe this is a mistake please reach out to your Account Administrator or 
				<a
					style="
						font-family: Montserrat;
						cursor: pointer;
						margin-top: 5px;
						text-align: center;
					"
					title="Open a service request in a new tab for GOALKeeper access"
					target="serviceRequest"
					href="https://globaloverview.atlassian.net/servicedesk/customer/portal/1/group/1/create/27"
				>
					open an IT Ticket.
				</a>
			</div>
        </main>
    </div>
</template>

<script>

export default {
	name:'AccessDenied',
	data(){
		return{
		}
	},
	components:{
		// DetailTabs,
		// Detail,
		// Tables,
		// BreadCrumbHeader
	},
	computed:{
		// currentPage:{
		// 	set(val) {
		// 		this.$store.state.accounts.accountTab =  val;
		// 	},
		// 	get() {
		// 		return this.$store.state.accounts.accountTab;
		// 	}
		// }
	},
	mounted(){
	},
	methods:{
	}
}
</script>

<style lang="scss">

</style>
